import { render, staticRenderFns } from "./NeumaticoReporteCosto.vue?vue&type=template&id=36e41e5c&scoped=true"
import script from "./NeumaticoReporteCosto.vue?vue&type=script&lang=js"
export * from "./NeumaticoReporteCosto.vue?vue&type=script&lang=js"
import style0 from "./NeumaticoReporteCosto.vue?vue&type=style&index=0&id=36e41e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e41e5c",
  null
  
)

export default component.exports